import React from 'react';
import { FaFacebookF, FaGithub, FaLinkedinIn } from 'react-icons/fa';
import { Link } from 'react-scroll';
import logo from "../../images/Anis Ayser.png";


const Footer = () => {
    return (
        <div className='pt-20'>
            <div className="w-full h-1 bg-gradient-to-l from-neutral-content absolute right-0 z-50"></div>

            <div className="">
                <footer className="footer footer-center p-10 bg-[#0f0f13bb] text-base-content rounded">
                    <div data-aos="fade-down" className="flex flex-wrap">
                        <Link activeClass="active" to="home" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={-50} duration={500}>
                            Hero
                        </Link>
                        <Link activeClass="active" to="about" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={-50} duration={500}>
                            About
                        </Link>
                        <Link activeClass="active" to="service" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Service
                        </Link>
                        <Link activeClass="active" to="portfolio" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Portfolio
                        </Link>
                        <Link activeClass="active" to="skills" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Skills
                        </Link>
                        <Link activeClass="active" to="testimonials" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Testimonials
                        </Link>
                        <Link activeClass="active" to="contact" className="btn btn-ghost capitalize text-md tracking-[1px]" spy={true} smooth={true} offset={50} duration={500}>
                            Contact
                        </Link>
                    </div>
                    <div>
                        <img data-aos="fade-down" src={logo} className="w-52 pb-5" alt="" />
                        <div data-aos="fade-down" className="grid grid-flow-col gap-4">
                            <a href='https://www.facebook.com/anisayser1/' target="_blank" rel="noopener noreferrer" className='cursor-pointer'><FaFacebookF className='text-4xl' /></a>
                            <a href='https://google.com' target="_blank" rel="noopener noreferrer" className='cursor-pointer'><FaLinkedinIn className='text-4xl' /></a>
                            <a href='https://github.com/anisayser' target="_blank" rel="noopener noreferrer" className='cursor-pointer'><FaGithub className='text-4xl' /></a>
                        </div>
                    </div>
                    <div>
                        <p>Copyright © 2022 - All right reserved by Anis Ayser</p>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default Footer;